<template>
    <v-data-table    
    :headers="HEADERS"
    :items="items"    
    :search="search"
    :hide-headers="isMobile || isPrint"        
    :hide-actions="true"
    :disable-initial-sort="true"
    :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
    <template v-slot:items="props">
        <tr v-if="isMobile || isPrint">
            <td>
                <div class="flex-content">
                    <div class="flex-item"><h3 class="pb-xs-0"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></h3></div>
                    <div class="flex-item" data-label="Date">{{ props.item.Date | stringDateFormat }}</div>
                    <div class="flex-item" data-label="Minister"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></div>
                    <div class="flex-item" data-label="Portfolio">
                        <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
                    </div>
                    <div class="flex-item" data-label="Tags">
                        <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
                    </div>                                
                </div>
            </td>
        </tr>
        <tr v-else>
            <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
            <td class="text-xs-left font-weight-bold"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></td>
            <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></td>                        
            <td class="text-xs-left">
                <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
            </td>
            <td class="text-xs-left">
                <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
            </td>
        </tr>
    </template>
</v-data-table>
</template>
<script>
import print from '../../mixins/print';
export default {
    props: ['items'],
    mixins: [print],
    created() {
        this.onResize();
    },
    methods: {
        onResize() {
            if (window.innerWidth < 1060) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        },
    },
    data() {
        return {
            isMobile: false,
            search: '',                
            HEADERS: [
                {
                    text: 'Date',
                    value: 'Date',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'Title',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Minister',
                    value: 'Minister.DisplayName',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Portfolio',
                    value: 'Portfolios',
                    align: 'left'                    
                },
                {
                    text: 'Tags',
                    value: 'Tags',
                    align: 'left'                    
                },                
            ],
        }
    }
}
</script>